import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import useAdminAuth from "../hooks/useAdminAuth";
import { ADMIN_SESSION_EVENT } from "../lib/axios";
import AdminAuthContext from "../contexts/AdminAuthContext";

export default function AdminRoute({ children }) {
  const { loading, loggedIn, role, username } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [toast, setToast] = useState({ open: false, message: "", type: "error" });
  const [softRedirecting, setSoftRedirecting] = useState(false);
  const handledRef = useRef(false);

  useEffect(() => {
    const onExpired = () => {
      if (handledRef.current) return; // 중복 방지
      handledRef.current = true;

      setToast({ open: true, message: "세션이 만료됐어요. 다시 로그인해 주세요.", type: "error" });
      setSoftRedirecting(true);

      // 토스트 잠깐 보여주고 로그인 페이지로 이동
      setTimeout(() => {
        navigate("/admin/login", { replace: true, state: { from: location.pathname } });
      }, 1200);
    };

    window.addEventListener(ADMIN_SESSION_EVENT, onExpired);
    return () => window.removeEventListener(ADMIN_SESSION_EVENT, onExpired);
  }, [navigate, location.pathname]);

  // 세션 만료 토스트 표시 중이면 화면 고정
  if (softRedirecting) {
    return (
      <div className="admin-scope dark flex min-h-screen items-center justify-center bg-background text-foreground">
        {toast.open && (
          <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[9999]">
            <div className="rounded-xl border border-rose-500/30 bg-rose-600/90 px-5 py-3 text-sm font-medium text-white shadow-lg">
              {toast.message}
            </div>
          </div>
        )}
        <p className="text-sm text-muted-foreground">로그인 페이지로 이동 중…</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="admin-scope dark flex min-h-screen items-center justify-center bg-background text-foreground">
        <p className="text-sm text-muted-foreground">로그인 상태 확인 중…</p>
      </div>
    );
  }
  if (!loggedIn) return <Navigate to="/admin/login" replace />;

  return (
    <AdminAuthContext.Provider value={{ role, username }}>
      {children}
    </AdminAuthContext.Provider>
  );
}
